module.exports = __webpack_public_path__ + "img/p2-52.d5b4f46d.png";